import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';
import { isDarkTheme } from '@/constants/Colors';
import { projectDiffPalette } from '@/lib/projectChangeDiff';

// Native Views supply full-row backgrounds without relying on CSS syntax
// highlighting. +/- markers and separate old/new gutters also work without color.
export default function ProjectDiffLines({ rows }) {
  const { theme, colors } = useTheme();
  const palette = projectDiffPalette(isDarkTheme(theme));
  return <View style={{ minWidth: 0 }}>
    {rows.map((row, index) => {
      const changed = row.kind === 'added' || row.kind === 'removed';
      const meta = row.kind === 'meta' || row.kind === 'hunk';
      const color = palette[row.kind] || colors.text_color_primary;
      return <View key={index} style={[styles.row, { backgroundColor: palette[`${row.kind}Background`] || 'transparent' }]}>
        {!meta && <View style={styles.gutter} accessible={false}>
          <Text style={[styles.number, { color }]}>{row.oldLine ?? ''}</Text>
          <Text style={[styles.number, { color }]}>{row.newLine ?? ''}</Text>
        </View>}
        {!meta && <Text style={[styles.marker, { color }]}>{changed ? row.kind === 'added' ? '+' : '−' : ' '}</Text>}
        <Text selectable style={[styles.code, { color }, meta && styles.meta]}>{row.text.slice(0, 4000) || ' '}</Text>
      </View>;
    })}
  </View>;
}
export function ProjectDiffCounts({ added, removed }) {
  const { theme } = useTheme();
  const palette = projectDiffPalette(isDarkTheme(theme));
  if (!Number.isFinite(added) || !Number.isFinite(removed)) return null;
  return <View style={styles.counts} accessibilityLabel={`${added} lines added, ${removed} lines removed`}>
    <Text size="xs" weight="medium" style={{ color: palette.added }}>+{added}</Text>
    <Text size="xs" weight="medium" style={{ color: palette.removed }}>−{removed}</Text>
  </View>;
}
const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'flex-start', minHeight: 23, paddingVertical: 2, paddingRight: 12 },
  gutter: { flexDirection: 'row', flexShrink: 0, paddingRight: 8, opacity: 0.8 },
  number: { width: 33, textAlign: 'right', fontFamily: Platform.OS === 'android' ? 'monospace' : 'Menlo', fontSize: 10, lineHeight: 19 },
  marker: { width: 18, fontFamily: Platform.OS === 'android' ? 'monospace' : 'Menlo', fontSize: 12, lineHeight: 19 },
  code: { flex: 1, minWidth: 0, fontFamily: Platform.OS === 'android' ? 'monospace' : 'Menlo', fontSize: 12, lineHeight: 19 },
  meta: { paddingHorizontal: 12, paddingVertical: 3 },
  counts: { flexDirection: 'row', alignItems: 'center', gap: 8 },
});
